import LogoImg from '/img/main/logo.png';
import LabelImg from '/img/main/label.png';
import LabelImgMobile from '/img/main/label-mobile.png';
import PartnerTextImg from '/img/main/partner-text.png';
import ParticipateInfoImg from '/img/main/participation-info.png';
import ParticipateInfoActiveImg from '/img/main/participation-info-active.png';
import SnsIcon1Img from '/img/sns-icon1.png';
import SnsIcon2Img from '/img/sns-icon2.png';
import SnsIcon3Img from '/img/sns-icon3.png';
import SnsIcon4Img from '/img/sns-icon4.png';
import GuideImg1Img from '/img/guide/guide-img1.png';
import GuideImg2Img from '/img/guide/guide-img2.png';
import GuideImg3Img from '/img/guide/guide-img3.png';
import GuideImg3_1Img from '/img/guide/guide-img3-1.png';
import GuideImg3_2Img from '/img/guide/guide-img3-2.png';
import GuideImg4Img from '/img/guide/guide-img4.png';
import NumberIcon1Img from '/img/guide/number-icon1.png';
import NumberIcon2Img from '/img/guide/number-icon2.png';
import NumberIcon3Img from '/img/guide/number-icon3.png';
import NumberIcon4Img from '/img/guide/number-icon4.png';
import CardImg from '/img/main/card.png';
import CheckImg from '/img/check.png';
import CheckActiveImg from '/img/check-active.png';
import QuestionIconImg from '/img/main/question-icon.png';
import CloseIconImg from '/img/close.png';
import WebFlareImageImg from '/img/main/flare-pc.png';
import MobileFlareImageImg from '/img/main/flare-mobile.png';
import ShowDownAppImg from '/img/main/showdown-app.png';
import UnionIconImg from '/img/main/union-icon.png';
import PartnerIconImg from '/img/main/partner.png';
import KakaoIconImg from '/img/main/kakao-icon.png';
import ArrowRightIconImg from '/img/guide/arrow-right-icon.png';
import BgImg from '/img/bg.png';
import PartnerIcon1Img from '/img/partner/partner-icon1.png';
import PartnerIcon2Img from '/img/partner/partner-icon2.png';
import PartnerIcon3Img from '/img/partner/partner-icon3.png';
import PartnerIcon4Img from '/img/partner/partner-icon4.png';
import AppIconImg from '/img/app-icon.png';
import TicketActiveImg from '/img/ticket/ticket-active.png';
import TicketInActiveImg from '/img/ticket/ticket-inactive.png';
import CardMainImg from '/img/ticket/card-main.png';
import CardMainWithUseImg from '/img/ticket/card-main-with-use.png';
import LocationIconImg from '/img/main/location-icon.png';
import DeleteIconImg from '/img/ticket/delete.png';
import UsedStamp from '/img/ticket/icon-stamp.png';
import CloseWhite from '/img/modal/close-white.png';

const addNoCacheParam = (url: string): string => {
  return `${url}?t=20260211`;
};

export const ImageUtils = {
  Logo: addNoCacheParam(LogoImg),
  Label: addNoCacheParam(LabelImg),
  LabelMobile: addNoCacheParam(LabelImgMobile),
  PartnerText: addNoCacheParam(PartnerTextImg),
  ParticipateInfo: addNoCacheParam(ParticipateInfoImg),
  ParticipateInfoActive: addNoCacheParam(ParticipateInfoActiveImg),
  SnsIcon1: addNoCacheParam(SnsIcon1Img),
  SnsIcon2: addNoCacheParam(SnsIcon2Img),
  SnsIcon3: addNoCacheParam(SnsIcon3Img),
  SnsIcon4: addNoCacheParam(SnsIcon4Img),
  GuideImg1: addNoCacheParam(GuideImg1Img),
  GuideImg2: addNoCacheParam(GuideImg2Img),
  GuideImg3: addNoCacheParam(GuideImg3Img),
  GuideImg3_1: addNoCacheParam(GuideImg3_1Img),
  GuideImg3_2: addNoCacheParam(GuideImg3_2Img),
  GuideImg4: addNoCacheParam(GuideImg4Img),
  NumberIcon1: addNoCacheParam(NumberIcon1Img),
  NumberIcon2: addNoCacheParam(NumberIcon2Img),
  NumberIcon3: addNoCacheParam(NumberIcon3Img),
  NumberIcon4: addNoCacheParam(NumberIcon4Img),
  Card: addNoCacheParam(CardImg),
  Check: addNoCacheParam(CheckImg),
  CheckActive: addNoCacheParam(CheckActiveImg),
  QuestionIcon: addNoCacheParam(QuestionIconImg),
  CloseIcon: addNoCacheParam(CloseIconImg),
  WebFlareImage: addNoCacheParam(WebFlareImageImg),
  MobileFlareImage: addNoCacheParam(MobileFlareImageImg),
  ShowDownApp: addNoCacheParam(ShowDownAppImg),
  UnionIcon: addNoCacheParam(UnionIconImg),
  PartnerIcon: addNoCacheParam(PartnerIconImg),
  KakaoIcon: addNoCacheParam(KakaoIconImg),
  ArrowRightIcon: addNoCacheParam(ArrowRightIconImg),
  Bg: addNoCacheParam(BgImg),
  PartnerIcon1: addNoCacheParam(PartnerIcon1Img),
  PartnerIcon2: addNoCacheParam(PartnerIcon2Img),
  PartnerIcon3: addNoCacheParam(PartnerIcon3Img),
  PartnerIcon4: addNoCacheParam(PartnerIcon4Img),
  AppIcon: addNoCacheParam(AppIconImg),
  TicketActive: addNoCacheParam(TicketActiveImg),
  TicketInActive: addNoCacheParam(TicketInActiveImg),
  CardMain: addNoCacheParam(CardMainImg),
  CardMainWithUse: addNoCacheParam(CardMainWithUseImg),
  LocationIcon: addNoCacheParam(LocationIconImg),
  DeleteIcon: addNoCacheParam(DeleteIconImg),
  UsedStamp: addNoCacheParam(UsedStamp),
  CloseWhite: addNoCacheParam(CloseWhite),
};
